import { useEffect } from 'react';

export const useGoogleConsent = () => {
  useEffect(() => {
    // Initialize Google Consent Mode v2 with default values
    if (typeof window.gtag === 'function') {
      // Set default consent state (denied by default for GDPR compliance)
      // Explicitly deny third-party cookies until user consent
      window.gtag('consent', 'default', {
        'analytics_storage': 'denied',
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'functionality_storage': 'granted', // Essential for site functionality
        'personalization_storage': 'denied',
        'security_storage': 'granted', // Essential for security
        'third_party_storage': 'denied', // Explicitly deny third-party cookies
        'wait_for_update': 2000, // Wait up to 2 seconds for consent update
      });

      // Check if user has previously given consent
      const cookieConsent = localStorage.getItem('cookie_consent');
      if (cookieConsent === 'accepted') {
        // User previously accepted, grant all consents including third-party cookies
        window.gtag('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'functionality_storage': 'granted',
          'personalization_storage': 'granted',
          'security_storage': 'granted',
          'third_party_storage': 'granted',
        });
      } else if (cookieConsent === 'declined') {
        // User previously declined, keep non-essential denied
        window.gtag('consent', 'update', {
          'analytics_storage': 'denied',
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'functionality_storage': 'granted',
          'personalization_storage': 'denied',
          'security_storage': 'granted',
        });
      }
    }
  }, []);

  const updateConsent = (granted: boolean) => {
    if (typeof window.gtag === 'function') {
      if (granted) {
        window.gtag('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'functionality_storage': 'granted',
          'personalization_storage': 'granted',
          'security_storage': 'granted',
          'third_party_storage': 'granted',
        });
      } else {
        window.gtag('consent', 'update', {
          'analytics_storage': 'denied',
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied',
          'functionality_storage': 'granted',
          'personalization_storage': 'denied',
          'security_storage': 'granted',
          'third_party_storage': 'denied',
        });
      }
    }
  };

  const getConsentStatus = () => {
    const cookieConsent = localStorage.getItem('cookie_consent');
    return {
      hasConsent: cookieConsent === 'accepted',
      hasDeclined: cookieConsent === 'declined',
      needsConsent: !cookieConsent,
      consentDate: localStorage.getItem('cookie_consent_date'),
    };
  };

  return {
    updateConsent,
    getConsentStatus,
  };
};

export default useGoogleConsent;